"use client";

import Core from "@/components/core";
import useFetchLayananData from "@/hooks/fetchLayananData";

const LayananData = () => {
  const layanan = useFetchLayananData();

  return (
    <>
      {layanan.map((item) => (
        <Core.Card
          key={item.id}
          caseType="blog"
          image={`https://admin.macspace.id/public/${item.image}`}
          title={`Sparepart ${item.name}`}
          link={`/store/${item.slug}`}
        />
      ))}
    </>
  );
};

export default LayananData;
